import { useModalContext as c } from "../Modal/Modal.js";
import { useState as u, useMemo as i, useEffect as f } from "../../../external/preact/hooks/dist/hooks.module.js";
import m from "../../../core/Context/useCoreContext.js";
import { boolOrFalse as d } from "../../../utils/value/bool.js";
const T = {
  transaction: "transactionDetails",
  payout: "payoutDetails"
}, C = ({ hideTitle: t, type: e }) => {
  const { i18n: o } = m(), { withinModal: s } = c(), [a, r] = u(!1), n = i(() => a || d(t), [a, t]), l = i(() => o.get(T[e]), [o, e]);
  return f(() => {
    r(s);
  }, [s]), { hideTitle: n, title: l };
};
export {
  T as TITLES_BY_TYPE,
  C as default,
  C as useDataOverviewDetailsTitle
};
